import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps, KeyLabel } from 'src/Library/Types';
import {
  Modal,
  Button,
  Row,
  Col,
  Select,
  message,
  Icon,
  Form,
  Input,
  Upload,
  Spin,
  InputNumber,
  Checkbox,
} from 'src/Library/AntdLibComponents';
import { connect } from 'react-redux';
import { Form13Styles } from './Form13Request.styles';
import { ShipmentData, Form13VesselMaster } from 'src/components/pages/shipment-execution/SE.Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { FormComponentProps } from 'antd/lib/form';
import { renderLabelAndInput, renderSelectDropDown, renderLabelAndTextArea } from 'src/Library/Common';
import { isValidString, clone, isValidArray, getLabelFromKey } from 'src/Library/Helper';
import isEmpty from 'lodash/isEmpty';
import {
  form13FetchPODMasters,
  form13FetchCFS,
  form13FetchPendingContainers,
  form13SaveDraft,
  fetchForm13Draft,
  form13SaveRequest,
  form13FetchVesselMasters,
  retryForm13Request,
} from 'src/api/shipmentExecution';
import { Ports, CargoList, ContainerList } from 'src/components/common/Types/CommonTypes';
import { useDebounce } from 'src/hooks/useDebounce';
import { getFileExtension, arrayToObject } from 'src/utils/utils';
import { fileUploadOnS3 } from 'src/api/inquiry';
import { uploadImageToS3 } from 'src/api/salesorder';
import Form13UploadContainerDetails from './Form13UploadContainerDetails';
import { FORM13_CARGO_TYPES, getForm13MandatoryFields } from 'src/components/pages/shipment-execution/SE.utils';
import Protip from 'src/components/pages/Enquiry/Booking/Protip';
import { setVesselMasters } from 'src/actions/shipmentExecutionActions';
import { bindActionCreators } from 'redux';
import uniq from 'lodash/uniq';
import { Drawer } from 'antd';
import PrimaryIcon from '../../../create-shipment/create-shipment.svg/primary';
import ContainerIcon from '../../../create-shipment/create-shipment.svg/container';
import Asterisk from 'src/components/common/Asterisk';

interface IProps extends StylesProps<ReturnType<typeof Form13Styles>>, FormComponentProps {
  isVisible: boolean;
  handleCancel: () => void;
  shipmentData: ShipmentData;
  stuffingLocations: KeyLabel[];
  containerStatus: KeyLabel[];
  issueTo: KeyLabel[];
  vesselMaster: Form13VesselMaster;
  cargoTypes: CargoList[];
  odexForm13ReferenceNumber: string;
  odexForm13PyrCode: string;
  attachmentList: KeyLabel[];
  pendingContainers: number;
  setDocumentTab: () => void;
  isDocumentRequestTab?: boolean;
  onSaveDraft: () => void;
  onSubmit: (isSuccessful?: boolean, requestBody?, successResponse?) => void;
  imoClassCodes: KeyLabel [];
  setVesselMasters: (vesselMaster) => void;
  isRetryRequest?: boolean; // to retry containers failed during submission
  retryRequestData?;
  portForm13FieldConfigMap;
  mandatoryStuffingLocationAttachments;
  isResubmitRequest?: boolean; //resubmit request from details view
  containerISOCodeMap;
  containerTypes: ContainerList[];
}

interface StateProps {
  isDropdownSearching: boolean;
  podList: string[];
  searchTerm: string;
  cfsList;
  notifyParties: string[];
  containerDetails;
  trackingContainers;
  isTrackingContainersFetching: boolean;
  draftData;
  isSavingDraft?: boolean;
  isDraftProtipVisible?: boolean;
  isLoading?: boolean;
  isSubmitting?: boolean;
}

const Form13UploadModal = (props: IProps): React.ReactElement => {

  const {
    classes,
    isVisible,
    handleCancel,
    shipmentData,
    form,
    stuffingLocations,
    vesselMaster,
    cargoTypes,
    containerStatus,
    issueTo,
    odexForm13ReferenceNumber,
    odexForm13PyrCode,
    attachmentList,
    pendingContainers,
    setDocumentTab,
    onSaveDraft,
    isDocumentRequestTab,
    onSubmit,
    imoClassCodes,
    setVesselMasters,
    isRetryRequest,
    retryRequestData,
    portForm13FieldConfigMap,
    mandatoryStuffingLocationAttachments,
    isResubmitRequest,
    containerISOCodeMap,
    containerTypes,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    isDropdownSearching: false,
    podList: [],
    cfsList: [],
    notifyParties: [''],
    containerDetails: [{}],
    trackingContainers: [],
    isTrackingContainersFetching: false,
    draftData: {},
    searchTerm: '',
  });

  const [attachments, setAttachments] = React.useState({
    0: {
      uploading: false,
      name: '',
      url: '',
      type: '',
    },
  });

  const {
    isDropdownSearching,
    podList,
    searchTerm,
    cfsList,
    notifyParties,
    containerDetails,
    trackingContainers,
    draftData,
    isSavingDraft,
    isDraftProtipVisible,
    isLoading,
    isSubmitting,
  } = state;

  const labelInputProps = {
    colSpan: {
      left: 7,
      right: 17,
    },
    form,
    classes,
    formStyles: { marginBottom: 0 },
    disabled: isLoading,
  };

  const imoClassCodesMap = arrayToObject(imoClassCodes, 'key');

  const {
    getFieldDecorator,
    setFieldsValue,
    getFieldValue,
  } = form;

  const mandatoryFields = getForm13MandatoryFields({
    portForm13FieldConfigMap,
    shipmentData,
    mandatoryStuffingLocationAttachments,
    stuffingLocation: getFieldValue('stuffingLocation'),
    cargoType: getFieldValue('cargoType'),
  });

  const {
    isFPodMandatory,
    isConsigneeNameMandatory,
    isConsigneeAddressMandatory,
    isCargoDescriptionMandatory,
    isTerminalLoginIdMandatory,
    mandatoryStuffingAttachments,
    mandatoryCarogTypeAttachments,
    mandatoryStuffingAttachmentsBasedOnPOL,
  } = mandatoryFields;

  const prefillDataInForm = () : void => {
    if (isEmpty(draftData)) return;
    const {
      stuffingLocation,
      bookingNumber,
      terminalLoginId,
      siNo,
      vessel,
      viaNo,
      terminalCode,
      service,
      pod,
      cargoType,
      cargoDescription,
      containerStatus,
      cfs,
      notifyPartyContact,
      issueTo,
      consigneeName,
      consigneeAddress,
      isAdditionalHazNumbersSelected,
    } = draftData;

    const notifyParties = isValidArray(draftData.notifyParties) ? draftData.notifyParties : [''];
    const containerDetails = isValidArray(draftData.containerDetails) ?
      draftData.containerDetails?.map(item => ({
      ...item,
      vgmViaOdex: item.vgmViaOdex ? 'YES' : 'NO',
      imoNo: item.imoNo ? {
        key: item.imoNo,
        label: imoClassCodesMap[item.imoNo]?.label,
      } : undefined,
      imoNo1: item.imoNo1 ? {
        key: item.imoNo1,
        label: imoClassCodesMap[item.imoNo1]?.label,
      } : undefined,
      imoNo2: item.imoNo2 ? {
        key: item.imoNo2,
        label: imoClassCodesMap[item.imoNo2]?.label,
      } : undefined,
      imoNo3: item.imoNo3 ? {
        key: item.imoNo3,
        label: imoClassCodesMap[item.imoNo3]?.label,
      } : undefined,
    })) : [{}];

    setState({
      notifyParties,
      containerDetails,
    });

    setFieldsValue({
      stuffingLocation: stuffingLocation || undefined,
      bookingNumber: bookingNumber || undefined,
      terminalLoginId: terminalLoginId || undefined,
      siNo: siNo || undefined,
      vessel: vessel || undefined,
      viaNo: viaNo || undefined,
      terminalCode: terminalCode || undefined,
      service: service || undefined,
      cargoType: cargoType || undefined,
      cargoDescription: cargoDescription || undefined,
      containerStatus: containerStatus || undefined,
      notifyPartyContact: notifyPartyContact || undefined,
      issueTo: issueTo || undefined,
      consigneeName: consigneeName || undefined,
      consigneeAddress: consigneeAddress || undefined,
      isAdditionalHazNumbersSelected,
      pod: !isEmpty(pod) ? {
        key: pod,
        label: pod
      } : (!isEmpty(draftData.retryPod) ? draftData.retryPod : undefined),
      cfsId: !isEmpty(cfs) ? {
        key: cfs?.id,
        label: `${cfs.name} (${cfs.code})`
      } : (!isEmpty(draftData.retryCfs) ? draftData.retryCfs : undefined),
    }, () => {
      setFieldsValue({ notifyParties, containerDetails });
    });

    if (isValidArray(draftData.documents)) {
      const documents = draftData.documents?.map(item => ({
        ...item,
        type: {
          key: item.type,
          label: getLabelFromKey(item.type, attachmentList)
        }
      }));
      setAttachments(documents);
    }
  }

  const debouncedSearchCFS = useDebounce(searchTerm, 300);

  React.useEffect(() => {
    if (isResubmitRequest || isRetryRequest) {
      setState({ draftData: retryRequestData });
    } else {
      setPrefillingObject();
    }
    if (isEmpty(vesselMaster)) {
      fetchVesselMasters();
    }
    fetchContainers();
  }, []);

  React.useEffect(() => {
    prefillDataInForm();
  }, [draftData]);

  React.useEffect(() => {
    searchCFS(debouncedSearchCFS);
  }, [debouncedSearchCFS]);

  const polId = shipmentData?.originPolId || shipmentData?.originPortId;

  const fetchVesselMasters = async () => {
    const response = await form13FetchVesselMasters(
      shipmentData?.carrierId, polId
    );
    if (response.isSuccess) {
      if (!isEmpty(response.data)) {
        setVesselMasters(response.data);
      }
    } else {
      message.error(response.errorMessage)
    }
  }

  const setPrefillingObject = async () : Promise<void> => {
    setState({ isLoading: true });
    const response = await fetchForm13Draft(shipmentData?.id);
    if (response.isSuccess && !isEmpty(response?.data)) {
      setState({ draftData: response.data, isLoading: false });
    } else {
      setState({ isLoading: false });
    }
  }

  const searchCFS = async (queryString = '') => {
    setState({ isDropdownSearching: true });
    let cfsList = [];
    const response = await form13FetchCFS(queryString);
    if (response.isSuccess) {
      cfsList = response?.data || [];
    } else {
      message.error(response.errorMessage);
    }
    setState({ cfsList, isDropdownSearching: false });
  }

  const fetchContainers = async () => {
    setState({ isTrackingContainersFetching: true });
    let trackingContainers = []
    const response = await form13FetchPendingContainers(shipmentData?.id);
    if (response?.isSuccess) {
      trackingContainers = response.data?.map(item => ({
        containerNumber: item.containerNumber,
        containerSize: item.containerSize || undefined,
        containerType: item.containerType || undefined,
      })) || [];
    }
    setState({
      trackingContainers,
      isTrackingContainersFetching: false,
    });
  }

  const searchPOD = async () => {
    setState({ isDropdownSearching: true });
    let podList = [];
    const response = await form13FetchPODMasters(
      polId,
      getFieldValue('service'),
      getFieldValue('terminalCode'),
    );
    if (response.isSuccess) {
      podList = response?.data || [];
    } else {
      message.error(response.errorMessage);
    }
    setState({ podList, isDropdownSearching: false });
  }

  const handleSaveDraft = async () : Promise<void> => {
    const formValues = form.getFieldsValue();
    setState({ isSavingDraft: true });
    const body = createApiCallObject(formValues);
    const response = await form13SaveDraft(shipmentData?.id, draftData?.id, body)
    if (response.isSuccess) {
      setState({ isDraftProtipVisible: true, isSavingDraft: false });
    } else {
      message.error(response.errorMessage);
      setState({ isSavingDraft: false });
    }
  };

  const createApiCallObject = (formValues) => {
    let documents : any[] = [];
    Object.keys(attachments)?.forEach(item => {
      if (isValidString(attachments[item]?.url) &&
        isValidString(attachments[item]?.name) && !isEmpty(attachments[item]?.type)) {
        documents.push({
          url: attachments[item]?.url,
          name: attachments[item]?.name,
          type: attachments[item]?.type?.key,
        })
      }
    });

    const body = {
      documents,
      polId,
      carrierId: shipmentData?.carrierId,
      bookingNumber: formValues.bookingNumber,
      stuffingLocation: formValues.stuffingLocation,
      terminalLoginId: formValues.terminalLoginId,
      siNo: formValues.siNo,
      vessel: formValues.vessel,
      viaNo: formValues.viaNo,
      terminalCode: formValues.terminalCode,
      service: formValues.service,
      pod: formValues.pod?.key,
      fpodId: shipmentData?.destinationPodId || shipmentData?.destinationPortId,
      cargoType: formValues.cargoType,
      cargoDescription: formValues.cargoDescription,
      containerStatus: formValues.containerStatus,
      cfsId: formValues.cfsId?.key,
      notifyPartyContact: formValues.notifyPartyContact,
      notifyParties: formValues.notifyParties?.filter(item => isValidString(item)),
      issueTo: formValues.issueTo,
      consigneeName: formValues.consigneeName,
      consigneeAddress: formValues.consigneeAddress,
      isAdditionalHazNumbersSelected: formValues.isAdditionalHazNumbersSelected,
      containerDetails: formValues.containerDetails?.map(item => ({
        ...item,
        imoNo: item.imoNo?.key,
        imoNo1: item.imoNo1?.key,
        imoNo2: item.imoNo2?.key,
        imoNo3: item.imoNo3?.key,
        vgmViaOdex: item.vgmViaOdex === 'YES',
      })),
    }
    return body;
  }

  const handleSubmit = () : void => {
    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        return;
      }
      let invalidSizeTypeCombinationSelected : string[] = [];
      values?.containerDetails?.forEach(item => {
        const containerTypeSizeLabel = getLabelFromKey(item?.containerType, containerTypes);
        if (item?.containerType && item?.containerSize &&
          !isValidString(containerISOCodeMap?.[`${item?.containerType} ${item?.containerSize}`]) &&
          (invalidSizeTypeCombinationSelected?.indexOf(`${containerTypeSizeLabel} ${item?.containerSize}`) === -1)) {
          invalidSizeTypeCombinationSelected.push(
            `${containerTypeSizeLabel} ${item?.containerSize}`);
        }
      }
      );
      if (isValidArray(invalidSizeTypeCombinationSelected)) {
        message.error(`Cannot request form 13 for the container type and size combination(s)
        ${invalidSizeTypeCombinationSelected.join(', ')}`);
        return;
      }
      const mandatoryDocuments = uniq([
        ...mandatoryStuffingAttachments,
        ...mandatoryCarogTypeAttachments,
        ...mandatoryStuffingAttachmentsBasedOnPOL,
      ]);
      let documentsAdded : string[]= [];
      Object.keys(attachments)?.forEach(item => {
        if (isValidString(attachments[item]?.url) &&
          isValidString(attachments[item]?.name) && !isEmpty(attachments[item]?.type)) {
            documentsAdded.push(attachments[item]?.type?.key)
        }
      });
      if (isValidArray(mandatoryDocuments)) {
        let missingDocuments : any[] = [];
        mandatoryDocuments.forEach((item) => {
          if (!documentsAdded?.includes(item)) {
            missingDocuments.push(getLabelFromKey(item, attachmentList))
          }
        });

        if (isValidArray(missingDocuments)) {
          message.error(
            `Attachment(s) ${missingDocuments.join(', ')}
             ${missingDocuments.length > 1 ? 'are' : 'is' } required`
          , 10);
          return;
        }
      }
      setState({ isSubmitting: true });
      const body = createApiCallObject(values);
       // !isRetryRequest - this is to resubmit the containers with errors during submission
      const response = (isResubmitRequest && !isRetryRequest) ?
        await retryForm13Request(shipmentData?.id, draftData?.id, {
          ...body,
          previousContainerNumber: retryRequestData?.containerDetails?.[0]?.containerNumber,
        }) : await form13SaveRequest(shipmentData?.id, draftData?.id, body)
      if (response.isSuccess) {
        onSubmit(true, {
          ...body,
          retryPod: values?.pod,
          retryCfs: values?.cfsId,
          id: draftData?.id,
        }, response.data);
        setState({ isSubmitting: false });
      } else {
        message.error(response.errorMessage);
        setState({ isSubmitting: false });
      }
    });
  }

  const renderFooter = () : React.ReactElement => {
    return (
      <React.Fragment>
        <div>
          {!isResubmitRequest && <Button
            className={classes.saveDraftButton}
            size="large"
            onClick={() => handleSaveDraft()}
            disabled={isLoading}
            loading={isSavingDraft}
          >Save Draft</Button>}
          <Button
            size="large"
            disabled={isLoading}
            className={classes.submitButton}
            loading={isSubmitting}
            onClick={() => handleSubmit()}
          >
            Submit
          </Button>
        </div>
      </React.Fragment>
    );
  };

  const renderCarrierInfo = () : React.ReactElement => {
    const field = <Select
      className={classes.selectField}
      disabled={true}
      value={shipmentData?.carrierName}
    />;
    return renderLabelAndField(
      <>Carrier<Asterisk /></>,
      field,
    );
  };

  const renderPOLInfo = () : React.ReactElement => {
    const field = <Select
      className={classes.selectField}
      disabled={true}
      value={shipmentData?.originPolName || shipmentData?.originPortName}
    />;
    return renderLabelAndField(
      <>POL<Asterisk /></>,
      field,
    );
  };

  const handleChangeVessel = (option) : void => {
    setFieldsValue({
      viaNo: option?.props?.viaNo,
      service: option?.props?.service,
      terminalCode: option?.props?.terminalCode,
      pod: undefined,
    });
  };

  const renderVessel = () : React.ReactElement => {
    const field = <Form.Item style={{ marginBottom: 0 }}>
      {getFieldDecorator('vessel', {
        rules: [
          { required: true, message: 'Required' },
          { max: 20, message: 'Maximin 20 characters allowed' },
        ],
      })(
        <Select
          getPopupContainer={(trigger: any) => trigger.parentNode}
          className={classes.selectField}
          showSearch
          allowClear
          disabled={isLoading || isResubmitRequest}
          optionFilterProp="children"
          placeholder="Select Vessel"
          dropdownMatchSelectWidth={false}
          onChange={(val, options) => handleChangeVessel(options)}
        >
          {!isEmpty(vesselMaster) && Object.keys(vesselMaster)?.map(key =>
            <Select.Option key={key} { ...vesselMaster[key] }>{vesselMaster[key]?.vessel}</Select.Option>
          )}
        </Select>
      )}
    </Form.Item>;
    return renderLabelAndField(
      <>Vessel<Asterisk /></>,
      field,
    );
  };

  const renderViaNo = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: <>Via No<Asterisk /></>,
        key: 'viaNo',
        placeholder: 'Via No',
        disabled: true,
        rules: [
          { required: true, message: 'Required' },
          { max: 20, message: 'Maximum 20 characters allowed' },
        ],
      })
    );
  };

  const renderTerminal = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        label: <>Terminal<Asterisk /></>,
        key: 'terminalCode',
        disabled: true,
        placeholder: 'Enter Terminal',
        rules: [
          { required: true, message: 'Required' },
          { max: 50, message: 'Maximum 50 characters allowed' },
        ],
      })
    );
  };

  const renderService = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: 'Service',
        key: 'service',
        placeholder: 'Service',
        disabled: true,
        rules: [{ max: 100, message: 'Maximum 100 characters allowed' }],
      })
    );
  };

  const renderOriginInfo = () : React.ReactElement => {
    const field = <Form.Item style={{ marginBottom: 0 }}>
      {getFieldDecorator('stuffingLocation', {
        rules: [{
          required: true, message: 'Required',
        }],
      })(
        <Select
          getPopupContainer={(trigger: any) => trigger.parentNode}
          className={classes.selectField}
          showSearch
          allowClear
          disabled={isLoading || isResubmitRequest}
          optionFilterProp="children"
          dropdownMatchSelectWidth={false}
          placeholder="Select Origin"
        >
          {stuffingLocations?.map(item =>
            <Select.Option key={item.key}>{item.label}</Select.Option>
          )}
        </Select>
      )}
    </Form.Item>;
    return renderLabelAndField(
      <>Origin<Asterisk /></>,
      field,
      {
        left: 7,
        right: 17,
      },
    );
  };

  const renderBookingNumber = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        label: <>Booking No<Asterisk /></>,
        key: 'bookingNumber',
        placeholder: 'Enter Booking Number',
        initialValue: shipmentData?.bookingNumber,
        disabled: isValidString(shipmentData?.bookingNumber) || isLoading || isResubmitRequest,
        rules: [{
          required: true, message: 'Required',
        }],
      })
    );
  };

  const renderTerminalLoginId = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: <>Terminal Login Id{isTerminalLoginIdMandatory ? <Asterisk /> : null}</>,
        key: 'terminalLoginId',
        placeholder: 'Enter Terminal Login Id',
        disabled: isLoading || isResubmitRequest,
        rules: [
          { required: isTerminalLoginIdMandatory, message: 'Required' },
          { max: 200, message: 'Maximum 200 characters allowed' },
        ],
        labelStyles: { marginTop: '4px' },
      })
    );
  };

  const renderSINo = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        label: 'SI No',
        key: 'siNo',
        placeholder: 'Enter SI No',
        disabled: isLoading || isResubmitRequest,
        rules: [
          { max: 20, message: 'Maximum 20 characters allowed' },
        ],
      })
    );
  };

  const renderLabelAndField = (label, field, colSpan?, labelStyles?) : React.ReactElement => {
    return (
      <React.Fragment>
        <Col span={colSpan?.left || 7} className={classes.label} style={{ ...labelStyles }}>
          {label}
        </Col>
        <Col span={colSpan?.right || 17}>
          {field}
        </Col>
      </React.Fragment>
    );
  };

  const renderPOD = () : React.ReactElement => {
    const field = <Form.Item style={{ marginBottom: 0 }}>
      {getFieldDecorator('pod', {
        rules: [
          { required: true, message: 'Required' },
        ],
      })(
        <Select
          getPopupContainer={(trigger: any) => trigger.parentNode}
          className={classes.selectField}
          showSearch
          disabled={!getFieldValue('vessel') || !getFieldValue('terminalCode') || isLoading || isResubmitRequest}
          onFocus={() => searchPOD()}
          allowClear
          labelInValue
          optionFilterProp="children"
          placeholder="Select POD"
          dropdownMatchSelectWidth={false}
          dropdownRender={menu => renderSelectDropDown(menu, isDropdownSearching)}
        >
          {podList?.map(item =>
            <Select.Option key={item}>{item}</Select.Option>
          )}
        </Select>
      )}
    </Form.Item>;
    return renderLabelAndField(
      <>POD<Asterisk /></>,
      field,
    );
  };

  const renderFPOD = () : React.ReactElement => {
    const field = <Select
      className={classes.selectField}
      disabled={true}
      value={shipmentData?.destinationPodName || shipmentData?.destinationPortName}
    />;
    return renderLabelAndField(
      <>FPOD{isFPodMandatory ? <Asterisk /> : null}</>,
      field,
      {
        left: 7,
        right: 17,
      },
    );
  };

  const renderSelect = (props) : React.ReactElement => {
    const {
      key, placeholder, arrayList, initialValue, rules, resetField,
    } = props;
    return (
      <Form.Item style={{ marginBottom: 0 }}>
        {getFieldDecorator(`${key}`, {
          rules,
          initialValue,
        })(
          <Select
            getPopupContainer={(trigger: any) => trigger.parentNode}
            className={classes.selectField}
            showSearch
            allowClear
            disabled={isLoading || isResubmitRequest}
            optionFilterProp="children"
            placeholder={placeholder}
            dropdownMatchSelectWidth={false}
            onChange={() => {
              if (resetField) {
                containerDetails?.forEach((item, index) => {
                  setFieldsValue({
                    [`containerDetails[${index}].containerType`]: undefined
                  })
                })
              }
            }}
          >
            {arrayList?.map(item =>
              <Select.Option key={item.key}>{item.label}</Select.Option>
            )}
          </Select>
        )}
      </Form.Item>
    );
  };

  const renderCargoType = () : React.ReactElement => {
    const field = renderSelect({
      key: 'cargoType',
      placeholder: 'Select Cargo Type',
      arrayList: cargoTypes,
      rules: [{ required: true, message: 'Required' }],
      initialValue: shipmentData?.cargoType,
      resetField: true,
    });
    return renderLabelAndField(
      <>Cargo Type<Asterisk /></>,
      field,
    );
  };

  const renderContainerStatus = () : React.ReactElement => {
    const field = renderSelect({
      key: 'containerStatus',
      placeholder: 'Select Container Status',
      arrayList: containerStatus,
      rules: [{ required: true, message: 'Required' }],
      initialValue: 'F'
    });
    return renderLabelAndField(
      <>Container Status<Asterisk /></>,
      field,
      {
        left: 7,
        right: 17,
      },
      { marginTop: '4px' },
    );
  };

  const renderCFS = () : React.ReactElement => {
    const field = <Form.Item style={{ marginBottom: 0 }}>
      {getFieldDecorator('cfsId', {
        rules: [
          { required: false, message: 'Required' },
        ],
      })(
        <Select
          getPopupContainer={(trigger: any) => trigger.parentNode}
          className={classes.selectField}
          showSearch
          onFocus={() => setState({ searchTerm: '' })}
          onSearch={(searchTerm) => setState({ searchTerm })}
          allowClear
          labelInValue
          optionFilterProp="children"
          placeholder="Select CFS"
          dropdownMatchSelectWidth={false}
          disabled={isLoading || isResubmitRequest}
          dropdownRender={menu => renderSelectDropDown(menu, isDropdownSearching)}
        >
          {cfsList?.map(item =>
            <Select.Option key={item.id}>{`${item.name} (${item.code})`}</Select.Option>
          )}
        </Select>
      )}
    </Form.Item>;
    return renderLabelAndField(
      'CFS',
      field,
    );
  };

  const renderCargoDescription = () : React.ReactElement => {
    return (
      renderLabelAndTextArea({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: <>Cargo Description{isCargoDescriptionMandatory ? <Asterisk /> : null}</>,
        key: 'cargoDescription',
        placeholder: 'Cargo Description',
        rules: [
          { required: isCargoDescriptionMandatory, message: 'Required' },
          { max: 250, message: 'Maximum 250 characters allowed' },
        ],
        rows: 3,
        disabled: isLoading || isResubmitRequest,
      })
    );
  };

  const renderBasicDetails =  () : React.ReactElement => {
    return (
      <Row className={classes.box}>
        <Col span={3} className={classes.contentHeading}>
          <div className={classes.boxIcon}>
            <PrimaryIcon className={classes.boxIcon} />
          </div>
          Basic Details
        </Col>
        <Col span={20}>
          <Row style={{ marginBottom: '16px' }}>
            <Col span={8}>
              {renderCarrierInfo()}
            </Col>
          </Row>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>
              {renderPOLInfo()}
            </Col>
            <Col span={2} />
            <Col span={8}>
              {renderOriginInfo()}
            </Col>
          </Row>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>
              {renderBookingNumber()}
            </Col>
            <Col span={2} />
            <Col span={8}>
              {renderTerminalLoginId()}
            </Col>
          </Row>
          <Row style={{ marginBottom: 4 }}>
            <Col span={8}>
              {renderSINo()}
            </Col>
          </Row>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>
              {renderVessel()}
            </Col>
            <Col span={2} />
            <Col span={8}>
              {renderViaNo()}
            </Col>
          </Row>
          <Row style={{ marginBottom: 4 }}>
            <Col span={8}>
              {renderTerminal()}
            </Col>
            <Col span={2} />
            <Col span={8}>
              {renderService()}
            </Col>
          </Row>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>
              {renderPOD()}
            </Col>
            <Col span={2} />
            <Col span={8}>
              {renderFPOD()}
            </Col>
          </Row>
          <Row>
            <Col span={8} className={classes.flexColumn}>
              <div style={{ marginBottom: '4px' }}>{renderCargoType()}</div>
              <div style={{ marginBottom: '4px' }}>{renderContainerStatus()}</div>
              <div style={{ marginBottom: '4px' }}>{renderCFS()}</div>
            </Col>
            <Col span={2} />
            <Col span={8} className={classes.flexColumn}>
              <div style={{ marginBottom: '4px' }}>{renderCargoDescription()}</div>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const renderMobileInput = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: <>Mobile<Asterisk /></>,
        key: 'notifyPartyContact',
        placeholder: 'Enter Mobile Number',
        rules: [
          { required: true, message: 'Required' },
          { max: 80, message: 'Maximum 80 characters allowed' },
        ],
        disabled: isLoading || isResubmitRequest,
      })
    );
  };

  const handleAddMore = () => {
    const newList = [
      ...notifyParties,
      '',
    ]
    setState({ notifyParties: newList });
  };

  const handleRemove = (index) => {
    const newList = form.getFieldValue('notifyParties');
    newList.splice(index, 1);
    setState({ notifyParties: newList });
    form.setFieldsValue({
      notifyParties: newList,
    });
  };

  const renderNotifyTo = () : React.ReactElement => {
    return (
      <React.Fragment>
        <Col span={7} className={classes.label}>
          Notify To
        </Col>
        <Col span={17} className={classes.flexColumn}>
          {notifyParties?.map((item, index) => (
            <div>
              <Col span={23}>
                <Form.Item style={{ marginBottom: 0 }}>
                  {form.getFieldDecorator(`notifyParties[${index}]`, {
                    rules: [{ type: 'email', message: 'Please enter a valid Email Id' }],
                  })(
                    <Input
                      placeholder="Enter email"
                      disabled={isLoading || isResubmitRequest}
                      className={classes.inputField}
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={1}>
                {!isResubmitRequest &&
                (notifyParties?.length !== 1 && index !== notifyParties?.length - 1) && <Icon type="close"
                  style={{ color: 'red', padding: '12px 0 0 6px' }}
                  onClick={() => handleRemove(index)}
                />}
              </Col>
            </div>
          ))}
          {!isResubmitRequest && <div
            className={classes.addMore}
            onClick={() => handleAddMore()}
          >+ Add More</div>}
        </Col>
      </React.Fragment>
    );
  };

  const renderContractParty =  () : React.ReactElement => {
    return (
      <Row className={classes.box}>
        <Col span={3} className={classes.contentHeading}>Contract Party</Col>
        <Col span={20}>
          <Col span={8}>{renderMobileInput()}</Col>
          <Col span={2} />
          <Col span={8}>{renderNotifyTo()}</Col>
        </Col>
      </Row>
    );
  };

  const renderIssueTo = () : React.ReactElement => {
    const field = renderSelect({
      key: 'issueTo',
      placeholder: 'Select Issue To',
      arrayList: issueTo,
      rules: [{ required: true, message: 'Required' }],
    });
    return renderLabelAndField(
      <>Issue To<Asterisk /></>,
      field,
      {
        left: 7,
        right: 17,
      },
    );
  };

  const renderShipperName = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: 'Shipper Name',
        key: 'shipperName',
        placeholder: 'Shipper Name',
        disabled: true,
        initialValue: shipmentData?.shipperName,
      })
    );
  };

  const renderCHAName = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: 'CHA Name',
        key: 'chanName',
        placeholder: 'CHA Name',
        disabled: true,
        initialValue: odexForm13PyrCode,
      })
    );
  };

  const renderCHANumber = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: 'CHA Number',
        key: 'chanNumber',
        placeholder: 'CHA Number',
        disabled: true,
        initialValue: odexForm13ReferenceNumber,
      })
    );
  };

  const renderConsigneeName = () : React.ReactElement => {
    return (
      renderLabelAndInput({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: <>Consignee Name{isConsigneeNameMandatory ? <Asterisk /> : null}</>,
        key: 'consigneeName',
        placeholder: 'Consignee Name',
        rules: [
          { required: isConsigneeNameMandatory, message: 'Required' },
          { max: 35, message: 'Maximum 35 characters allowed' },
        ],
        labelStyles: { marginTop: '2px' },
        disabled: isLoading || isResubmitRequest,
      })
    );
  };

  const renderConsigneeAddress = () : React.ReactElement => {
    return (
      renderLabelAndTextArea({
        ...labelInputProps,
        colSpan: {
          left: 7,
          right: 17,
        },
        label: <>Consignee Address {isConsigneeAddressMandatory ? <Asterisk /> : null}</>,
        key: 'consigneeAddress',
        placeholder: 'Consignee Address',
        rules: [
          { required: isConsigneeAddressMandatory, message: 'Required' },
          { max: 250, message: 'Maximum 250 characters allowed' },
        ],
        rows: 3,
        disabled: isLoading || isResubmitRequest,
      })
    );
  };

  const renderCustomerDetails =  () : React.ReactElement => {
    return (
      <Row className={classes.box}>
        <Col span={3} className={classes.contentHeading}>Customer <br/> Details</Col>
        <Col span={20}>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>{renderIssueTo()}</Col>
            <Col span={2} />
            <Col span={8}>{renderShipperName()}</Col>
          </Row>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>{renderCHAName()}</Col>
            <Col span={2} />
            <Col span={8}>{renderCHANumber()}</Col>
          </Row>
          <Row style={{ marginBottom: '4px' }}>
            <Col span={8}>{renderConsigneeName()}</Col>
            <Col span={2} />
            <Col span={8}>{renderConsigneeAddress()}</Col>
          </Row>
        </Col>
      </Row>
    );
  };

  const handleAddMoreContainer = () : void => {
    const containerCount = getFieldValue('containerCount');
    const containerAddedCount = containerDetails?.length || 0;
    let containerToBeAddedCount = containerCount;
    if ((containerCount + containerAddedCount) > pendingContainers) {
      containerToBeAddedCount = (pendingContainers - containerAddedCount);
    }
    if (containerToBeAddedCount !== containerCount) {
      message.error(`This booking consists of maximum ${pendingContainers} container(s)`, 5);
    }
    if (!containerToBeAddedCount || containerToBeAddedCount <= 0) return;
    const clonedContainerDetails = isValidArray(containerDetails) ? clone(containerDetails) : [];
    for (let i = 0; i < containerToBeAddedCount; i = i + 1) {
      clonedContainerDetails.push({});
    };
    message.success(`${containerToBeAddedCount} more container(s) added successfully`);
    setState({
      containerDetails: clonedContainerDetails,
    });
    setFieldsValue({
      containerCount: undefined,
    });
  };

  const handleRemoveContainer = (key) => {
    const containerDetails = form.getFieldValue('containerDetails');
    const clonedContainerDetails = isValidArray(containerDetails) ? clone(containerDetails) : [{}];
    clonedContainerDetails?.splice(key, 1);
    setState({ containerDetails: clonedContainerDetails || [{}] });
    setFieldsValue({ containerDetails: clonedContainerDetails || [{}] });
  }

  const renderAdditionalImoUnNumber = () : React.ReactElement => {
    return (
      <div>
        <Form.Item style={{ marginBottom: 0 }}>
          {getFieldDecorator('isAdditionalHazNumbersSelected', {
            initialValue: false,
            valuePropName: 'checked',
          })(
            <Checkbox
              disabled={isLoading}
            >
              Add additional IMO No. and UN No. fields
            </Checkbox>
          )}
        </Form.Item>
      </div>
    );
  }

  const getContainers = async (prefillAllContainer?) => {
    let containerList = isValidArray(trackingContainers) ? clone(trackingContainers) : [];
    const containers = containerList?.map(item => ({
      containerNumber: item.containerNumber,
      containerSize: item.containerSize,
      containerType: item.containerType,
      agentSealNo: undefined,
      customSealNo: undefined,
      shipBillInvoiceNo: undefined,
      vgmViaOdex: 'YES',
      weight: undefined,
      packageCount: undefined,
      doNo: undefined,
      temperature: undefined,
      voltage: undefined,
      vehicleNo: undefined,
      haulier: undefined,
      driverName: undefined,
      driverLicenseNo: undefined,
      remarks: undefined,
      imoNo: undefined,
      unNo: undefined,
      imoNo1: undefined,
      unNo1: undefined,
      imoNo2: undefined,
      unNo2: undefined,
      imoNo3: undefined,
      unNo3: undefined,
      leftDimensions: undefined,
      rightDimensions: undefined,
      topDimensions: undefined,
      backDimensions: undefined,
      frontDimensions: undefined,
      odcUnits: undefined,
    }));
    if (prefillAllContainer) {
      const pendingContainersList = isValidArray(containers) ? containers.slice(0, pendingContainers) : containerDetails;
      setState({
        containerDetails: pendingContainersList,
      });
      setFieldsValue({
        containerDetails: pendingContainersList,
      });
    }
  }

  const renderContainerDetails =  () : React.ReactElement => {
    return (
      <Row className={classes.box}>
        <Col span={3} className={classes.contentHeading}>
          <div className={classes.boxIcon}>
            <ContainerIcon className={classes.boxIcon} />
          </div>
          Container <br/> Details
        </Col>
        <Col span={20}>
          {getFieldValue('cargoType') === FORM13_CARGO_TYPES.HAZARDOUS && renderAdditionalImoUnNumber()}
          {!isResubmitRequest && trackingContainers?.length >= pendingContainers && <div>
            <span
              className={classes.addMore}
              style={{ marginBottom: '6px', fontWeight: 600 }}
              onClick={() => getContainers(true)}
            >Click here </span>
            to add all
            <span style={{ fontWeight: 600 }}> {pendingContainers} container(s) </span> details from the Booking
            {isValidString(shipmentData?.bookingNumber) &&
              <span style={{ fontWeight: 600 }}> #{shipmentData?.bookingNumber}</span>}
          </div>}
          <Row>
            {containerDetails?.map((item, index) => (
              <div key={index} style={{ backgroundColor: '#FAFAFA',  margin: '16px 24px 0 0' }}>
                <Form13UploadContainerDetails
                  form={form}
                  containerKey={index}
                  containerDetails={containerDetails}
                  selectedCargoType={getFieldValue('cargoType')}
                  handleRemoveContainer={handleRemoveContainer}
                  shipmentData={shipmentData}
                  renderLabelAndField={renderLabelAndField}
                  containerNoList={trackingContainers}
                  getContainers={getContainers}
                  isLoading={isLoading}
                  isAdditionalHazNumbersSelected={getFieldValue('isAdditionalHazNumbersSelected')}
                  draftData={draftData}
                  mandatoryFields={mandatoryFields}
                />
              </div>
            ))}
          </Row>
          {!isResubmitRequest && <div className={classes.flexRow} style={{ marginTop: '12px' }}>
            <span className={classes.contentLabel} style={{ marginRight: '12px' }}>Add More Containers</span>
            <Form.Item style={{ width: '6%', margin: '0 8px 0 0' }}>
              {getFieldDecorator('containerCount')(
                <InputNumber
                  placeholder="Count"
                  precision={0}
                  min={0}
                  className={classes.inputNumberField}
                  disabled={isLoading}
                />
              )}
            </Form.Item>
            <Button
              className={classes.addContainerButton}
              onClick={handleAddMoreContainer}
              size="small"
              disabled={containerDetails?.length === pendingContainers}
              style={{ marginRight: '8px' }}
            >Add</Button>
          </div>}
        </Col>
      </Row>
    );
  };

  const s3LinkRequest = async ({ file }, ind) => {
    setAttachments(prevState => {
      return {
        ...prevState,
        [ind]: {
          ...prevState[ind],
          uploading: true,
        },
      };
    });
    const extension = getFileExtension(file.name);
    const response = await fileUploadOnS3({
      extension,
      fileName: file.name,
      document_type: file.type,
      initialPath: 'form13',
    });
    if (response.isSuccess) {
      const upload = await uploadImageToS3(file, response.data.post, extension);
      if (upload.isSuccess) {
        setAttachments(prevState => {
          return {
            ...prevState,
            [ind]: {
              ...prevState[ind],
              name: file.name,
              url: response.data.get,
              uploading: false,
            },
          };
        });
      }
    } else {
      message.error(response.errorMessage);
      setAttachments(prevState => {
        return {
          ...prevState,
          [ind]: {
            ...prevState[ind],
            uploading: false,
          },
        };
      });
    }
  };

  const attachmentMap = arrayToObject(attachmentList, 'key');

  const getRemainingImoNoList = () => {
    const attachmentsAdded = Object.keys(attachments)?.filter(item =>
      attachments[item]?.type)?.map(attachment => attachments[attachment]?.type?.key);
    attachmentsAdded?.forEach(item => {
      if (item) {
        delete attachmentMap[item]
      }
    });
    return attachmentMap;
  };

  const renderDocuments =  () : React.ReactElement => {
    const remainingAttachments = getRemainingImoNoList();
    return (
      <Row className={classes.box} style={{ borderBottom: 0 }}>
        <Col span={3} className={classes.contentHeading}>
          <div className={classes.boxIcon}>
            <Icon
              style={{ fontSize: 32 }}
              type="paper-clip"
              className={classes.boxIcon}
            />
          </div>
          Attachment
        </Col>
        <Col span={20}>
        <div className={classes.flexColumn}>
          {Object.keys(attachments)?.map((attachment) =>
            (<div
              className={classes.flexRow}
              key={attachment}
              style={{
                marginBottom: '8px',
              }}
            >
              <Col span={6} className={classes.flexRow}>
                <Select
                  getPopupContainer={(trigger: any) => trigger.parentNode}
                  value={attachments[attachment].type}
                  disabled={isLoading || isResubmitRequest}
                  labelInValue
                  placeholder="Select attachment"
                  onChange={(type) => {
                    setAttachments(prevState => {
                      return {
                        ...prevState,
                        [attachment]: {
                          ...prevState[attachment],
                          type,
                        },
                      };
                    });
                  }}
                  className={classes.selectField}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ zIndex: 2000 }}
                >
                  {remainingAttachments && Object.keys(attachmentMap)?.map((item) => (
                    <Select.Option key={remainingAttachments[item].key}>
                      {remainingAttachments[item].label}
                    </Select.Option>
                  ))}
                </Select>
              </Col>
              <Col span={3}>
                <Upload
                  showUploadList={false}
                  multiple={false}
                  accept={'.pdf'}
                  customRequest={(file) => s3LinkRequest(file, attachment)}
                >
                  <Button style={{ marginLeft: '10px' }} disabled={isLoading || isResubmitRequest}>
                    <Icon type="upload" /> Upload
                  </Button>
                </Upload>
              </Col>
            <Col span={15} className={classes.flexRow}
              style={{
                paddingLeft: '6px',
              }}
            >
              {attachments[attachment]?.uploading && <Spin style={{ marginTop: '5px' }} />}
              {attachments[attachment]?.url &&
                <div
                  className={classes.flexRow}
                  style={{
                    paddingTop: '3px',
                  }}
                >
                  <a href={attachments[attachment].url} style={{ marginRight: '5%' }}>
                    {attachments[attachment].name}
                  </a>
                  {!isResubmitRequest && <Icon
                    type="close"
                    style={{
                      color: 'red',
                      cursor: 'pointer',
                      margin: '4px 0 0 4px',
                    }}
                    onClick={() => {
                      setAttachments(prevState => {
                        return {
                          ...prevState,
                          [attachment]: {
                            ...attachments[attachment],
                            name: '',
                            url: '',
                          },
                        };
                      });
                    }}
                  />}
                </div>}
              </Col>
              </div>
            ))}
            {!isResubmitRequest && <div className={classes.flexRow}>
              <Icon
                type="plus"
                style={{
                  color: '#1890FF',
                  paddingTop: '2px',
                }}
              />
              <a
                onClick={() => {
                  setAttachments(prevState => {
                    return {
                      ...prevState,
                      [Object.keys(prevState)?.length]: {
                        name: '',
                        url: '',
                        type: '',
                      },
                    };
                  });
                }}
                style={{
                  color: '#1890FF',
                  marginLeft: '3px',
                  float: 'left',
                }}
              >
                Add more
              </a>
            </div>}
          </div>
        </Col>
      </Row>
    );
  };

  const renderProtip = () : React.ReactElement => {
    return (
      <Protip
      visible={isDraftProtipVisible}
      success={'Great News!'}
      message1={<span>
        Form has been successfully saved to draft. <a onClick={() => setDocumentTab()}>
          Click here</a> to view saved draft.
      </span>}
      message2={'Now you are being redirected to Tasks view'}
      okay={'Okay'}
      onOkay={() => {
        if (isDocumentRequestTab) {
          onSaveDraft();
        }
        onSubmit();
      }}
    />
    );
  }


  const renderSaveDraftButton = () => {
    if (isResubmitRequest) {
      return;
    }

    return (
      <Button
        className={classes.saveDraftButton}
        type="ghost"
        onClick={() => handleSaveDraft()}
        disabled={isLoading || isSubmitting}
        loading={isSavingDraft}
      >
        Save Draft
      </Button>
    );
  }

  const renderSubmitButton = () => {
    return (
      <Button
        type="primary"
        onClick={handleSubmit}
        disabled={isLoading || isSavingDraft}
        className={classes.submitButton}
        loading={isSubmitting}
      >
        Submit
      </Button>
    )
  }

  const renderHeader = (title: string) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div className = {classes.header}>
          <Icon
            type="close"
            onClick={handleCancel}
          />
          <span
            style={{ marginLeft: 10 }}>
            {title}
          </span>
        </div>
        <div>
          {renderSaveDraftButton()}
          {renderSubmitButton()}
        </div>
      </div>
    );
  }

  return (
    <Drawer
      visible={isVisible}
      width={'85%'}
      className={classes.main}
      title={renderHeader("Upload Form 13")}
      onClose={handleCancel}
      closable={false}
    >
      {isLoading && (
        <div
          style={{
            height: '100%',
            width: '100%',
            textAlign: 'center',
            top: '30%',
            zIndex: 1200,
            position: 'absolute',
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {renderBasicDetails()}
      {renderContractParty()}
      {renderCustomerDetails()}
      {renderContainerDetails()}
      {renderDocuments()}
      {isDraftProtipVisible && renderProtip()}
    </Drawer>
  );
};

const mapStateToProps = ({ masterData, shipmentExecutionReducer }, ownProps) => ({
  stuffingLocations: masterData.odexMasterData?.stuffingLocations,
  vesselMaster: shipmentExecutionReducer?.vesselMaster,
  cargoTypes: masterData.odexMasterData?.cargoTypes,
  containerStatus: masterData.odexMasterData?.containerStatus,
  issueTo: masterData.odexMasterData?.issueTo,
  odexForm13ReferenceNumber: masterData.odexForm13ReferenceNumber,
  odexForm13PyrCode: masterData.odexForm13PyrCode,
  attachmentList: masterData.odexMasterData?.attachmentList,
  pendingContainers: shipmentExecutionReducer.siPendingCount?.FORM13?.pendingContainerCount,
  imoClassCodes: masterData.odexMasterData?.imoClassCodes,
  portForm13FieldConfigMap: masterData.odexMasterData?.portForm13FieldConfigMap,
  mandatoryStuffingLocationAttachments: masterData.odexMasterData?.mandatoryStuffingLocationAttachments,
  containerISOCodeMap: masterData.odexMasterData?.containerISOCodeMap,
  containerTypes: masterData.odexMasterData?.containerTypes,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  setVesselMasters,
}, dispatch));

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(Form.create()(withStyles(Form13Styles)(Form13UploadModal))));
